class MiniAnnouncement extends HTMLElement {
  constructor() {
    super();
    
    this.slider = this.querySelector('.mini-announcement-slider');
    if (this.slider) this.initSlider();
  }

  initSlider() {
    const quoteSlider = new Swiper(this.slider, {
      slidesPerView: 1,
      loop: true,
      spaceBetween: 20,
      allowTouchMove: true,
      autoplay: {
        delay: 4000,
      },
      breakpoints: {
        768: {
          allowTouchMove: false,
        }
      }
    });
  }
}

customElements.define('mini-announcement', MiniAnnouncement);